import { render, staticRenderFns } from "./SubidaDocumento.vue?vue&type=template&id=24f33744"
import script from "./SubidaDocumento.vue?vue&type=script&lang=js"
export * from "./SubidaDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports